export default __webpack_public_path__ + "static/media/014-vase.bf6aa935.svg";